import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer';
import imgComplete from '../images/appComplete.png';
import imgPending from '../images/appHold.png';
import service from '../services/StatusEnquiryApiService';
import Loading from '../components/Loading';
import helper from '../factory/Helper';
import config from '../appconfig/config.json';
import { useHistory } from "react-router-dom";
import SubHeader from '../components/SubHeader';
import storage from '../factory/StorageFactory';
import CusGreenBtn from '../components/CusGreenBtn';
import BlueboxTextList from '../hybridcomponents/BlueboxTextList';
import BlueboxIconTxt from '../hybridcomponents/BlueboxIconTxt';
import { CusFormLabel } from '../validation/Form-Components';
import mData from '../hybriddata/mainform.json';
import nldata from '../hybriddata/nonlendingdata.json';


const SubAPLanding = (props) => {

    let timer;
    const applicantStatusComplete = 'submitted';
    const applicantStatusPending = 'pending';

    const history = useHistory();

    const [isLoading, setIsLoading] = useState(true); //default true;

    const [isError, setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [response, setResponse] = useState();

    const [completedApplicants, setCompletedApplicants] = useState([]);
    const [pendingApplicants, setPendingApplicants] = useState([]);

    useEffect(() => {
        console.log('@Submit useEffect');

        window.scrollTo(0, 0);
        getAndSetStateId();
        getData();
 
        return () => clearTimeout(timer);
    }, []);

 
    const getAndSetStateId = () => {  // get State Id from query string and store in localhost
    
        const queryString = require('query-string');
        const parsed = queryString.parse(props.location.search);
        let stateId = parsed.state;
        storage.setStateId(stateId);
    }

    const getData = () => {
        const sid = storage.getStateId();
        const rno = storage.getRefNo();

        service.getStatusEnquiry(sid, rno).then(res => {
          
            if (res.data.didError === false) {
                const resData = res.data.model.fields.request;
                setResponse(resData);
   
                getCompletedAndPendingPerson(resData);
            }
            else {
                setIsLoading(false);
                showErrMsg(config.error.GetApiFailed);
            }
        })
            .catch(err => {
                console.log('err=>', err);
                setIsLoading(false);
                showErrMsg(config.error.GetApiFailed);
            })
    }

    const getCompletedAndPendingPerson = (data) => {

        let completedArray = [], pendingArray = [];
        if (!Array.isArray(data.ApplicantsStatus)) {
            if (data.ApplicantsStatus.status.toLowerCase() === applicantStatusComplete) {
                completedArray.push(data.ApplicantsStatus)
            }
            else {
                pendingArray.push(data.ApplicantsStatus);
            }
        }
        else {
            for (let i in data.ApplicantsStatus) {

                if (data.ApplicantsStatus[i].status.toLowerCase() === applicantStatusComplete) {
                    completedArray.push(data.ApplicantsStatus[i]);
                }
                else {
                    pendingArray.push(data.ApplicantsStatus[i]);
                }
            }
        }

        setCompletedApplicants(completedArray);
        setPendingApplicants(pendingArray);
        setIsLoading(false);
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout()
    }

    const setErrMsgTimeout = () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const handleContinue = () => {
        console.log('handleContinue');
        const state= storage.getStateId();
        history.push(config.route.NSPersonDetails+'?state='+state);
    }

    const showDeadlineDate = () => {
        if(pendingApplicants.length !== 0 && response.StatusDtls.Deadline !== null) {
            return response.StatusDtls.Deadline;
        }
        return 'DDMMYYYY';
    }

    const showHelloTitle = () => {
        const totalNumOfAP = response.ApplicantsStatus.length;
        const completedNumOfAP= completedApplicants.length;
        const ratioAP = completedNumOfAP+'/'+totalNumOfAP;

        const text = 'Hello '+response.ApplicantName+'. Let’s continue with your joint application ('+ratioAP+' Done).'
        return text;
    }

    const getPurposeString = () => {
        let result = '',temp = [];
        
        if(response.StatusDtls.WCL === 'Y') {
          temp.push(mData.label.chkWCL);
        }
        if(response.StatusDtls.Property === 'Y') {
          temp.push(mData.label.chkProperty);
        }
        if(response.StatusDtls.Trade === 'Y'){
          temp.push(mData.label.chkTrade);
        }
        if(response.StatusDtls.GAS === 'Y') {
          temp.push(mData.label.chkGAS);
        }
        if(response.StatusDtls.ESG === 'Y') {
            temp.push(mData.label.chkESG);
        }
      
        if(temp.length === 1) {
          result = temp[0];
        }
        else {
          result = temp.join(', ');
        }
        
        return result;
      }

    const getNonLendingString = () => {
        let result = '',temp = [];

        if(response.StatusDtls.MYCurrentAccount === 'N' && response.StatusDtls.FXDeskServices === 'N'
        && response.StatusDtls.BusinessInsurance === 'N' && response.StatusDtls.SMEStartDigital === 'N'
        && response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'N') {
            result = 'Not Applicable';
            return result;
        }

        if(response.StatusDtls.MYCurrentAccount === 'Y') {
            temp.push(nldata.product1.title);
        }
        if(response.StatusDtls.FXDeskServices === 'Y') {
            temp.push(nldata.product2.title);
        }
        if(response.StatusDtls.BusinessInsurance === 'Y'){
            temp.push(nldata.product3.title);
        }
        if(response.StatusDtls.SMEStartDigital === 'Y') {
            temp.push(nldata.product4.title);
        }
        if(response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'Y') {
            temp.push(nldata.product5.title);
        }
          
        
        if(temp.length === 1) {
            result = temp[0];
        }
        else {
            result = temp.join(', ');
        }

        return result;
    }

    const isProductBTL = () => {
   
        if(response.StatusDtls.ProductType === config.bizFinancing.BTL) {
            return true;
        }

        return false;
    }

    const isProductAIP = () => {
   
        if(response.StatusDtls.ProductType === config.bizFinancing.AIP) {
            return true;
        }

        return false;
    }

    const isPureAIP = () => {
        if(isProductAIP() && response.StatusDtls.isExistingOTPAvailable === 'N') {
            return true;
        }
            
        return false;
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <div className="container-fluid">
            <SubHeader title={config.Branding.title} />  
            <FormContainer>
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <h2 style={{ color: 'orange', fontSize: '1.2em' }}>
                        {showHelloTitle()}
                    </h2>
                </div>
                <div style={{ textAlign: "center", justifyContent: 'space-evenly' }} >
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <img className="imgScc" src={imgComplete} alt="imgScc"></img><br />
                            <div className="bbline">{completedApplicants.length+ ' Application Complete'}</div><br />
                                {completedApplicants.map((item, idx) => (
                                <div style={{ paddingTop: "1em", textAlign: 'center' }} key={idx}>
                                    {item.name}
                                </div>
                                ))
                             }
                        </div>

                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <img className="imgScc" src={imgPending} alt="imgScc"></img><br />
                            <div className="bbline">{pendingApplicants.length+' Application Pending'}</div><br />
                            {pendingApplicants.map((item, idx) => (
                                <div style={{ paddingTop: "1em", textAlign: 'center' }} key={idx}>
                                    {item.name}
                                </div>
                                ))
                            }
                        </div>
                    </div>
                    <br/>
                    <CusGreenBtn lbtxt='Continue Joint Application' onClick={handleContinue} />
                    <div className="row around-xs inputPair elementVisible">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{textAlign:'center'}}>
                            <label className="box" id={'id77'} >Please complete application before<br/> 
                            {showDeadlineDate()} to avoid reapplying.</label>
                        </div>
                    </div>
                </div> 
                <div style={{padding: '10px 20px 10px 20px' }}>
                    <BlueboxIconTxt />
                </div>
              
                <div style={{ width: '100%', marginLeft: '-10px' }}>
                    <hr className="hrgoldline" />
                </div>

                <div style={{ marginLeft: '25px', margingRight: '25px' }}>
                    <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Application Number'}
                        id={'appNum'} name={response.StatusDtls.ApplicationNo} />

                    <CusFormLabel leftLabelId={'lbluen'} leftLabelName={'UEN'}
                        id={'uen'} name={response.StatusDtls.UEN} />

                    <CusFormLabel leftLabelId={'lblfacility'} leftLabelName={'Facility'}
                        id={'facility'} name={response.StatusDtls.Facility} />

                    <CusFormLabel leftLabelId={'lblfinanceType'} leftLabelName={'Financing Type'}
                        id={'financeType'} name={response.StatusDtls.FinancingType} />

                    {isProductAIP()?
                        <CusFormLabel leftLabelId={'lblPurpose'} leftLabelName={'Purpose'}
                            id={'purpose'} name={'Property'} />
                            :
                        <CusFormLabel leftLabelId={'lblPurpose'} leftLabelName={'Purpose'}
                            id={'purpose'} name={getPurposeString()} />
                    }

                    {!isPureAIP()&&
                    <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Amount'}
                        id={'amt'} name={response.StatusDtls.Amount
                            ? response.StatusDtls.Amount != null
                                    ? 'SGD ' + parseFloat(response.StatusDtls.Amount)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : ""
                    : ""} />
                    }

                    <CusFormLabel leftLabelId={'lblCombinedApp'} leftLabelName={'Combined Applications (Non-lending)'}
                        id={'combinedApp'} name={getNonLendingString()} />

                    <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={isProductBTL()?'Date':'Submission Date'}
                        id={'date'} name={response.StatusDtls.AppDate} />
                </div>

            </FormContainer>
         <br/>
        </div>
    )
}

export default SubAPLanding;